var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.428711C7.62296 0.428711 0.428955 7.62271 0.428955 16.4997C0.428955 25.3767 7.62296 32.5707 16.5 32.5707C25.377 32.5707 32.571 25.3767 32.571 16.4997C32.571 7.62271 25.377 0.428711 16.5 0.428711ZM16.467 25.1127C15.51 25.1127 14.751 24.3537 14.751 23.3967C14.751 23.2317 14.784 23.0997 14.817 22.9677H18.15C18.183 23.0997 18.216 23.2647 18.216 23.3967C18.183 24.3537 17.424 25.1127 16.467 25.1127ZM23.463 22.2087H9.47096V21.0537C9.47096 20.9217 9.53696 20.7897 9.63596 20.6577C9.63596 20.6577 11.121 19.0407 11.121 14.7837C11.121 11.4837 13.332 10.0977 15.18 9.66871V8.71171C15.18 8.01871 15.741 7.45771 16.434 7.45771C17.127 7.45771 17.688 8.01871 17.688 8.71171V9.66871C19.536 10.0977 21.78 11.4837 21.78 14.7837C21.78 19.0407 23.265 20.6247 23.298 20.6577C23.397 20.7567 23.463 20.8887 23.463 21.0537V22.2087Z",
    fill: "#5890DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.df69351045782e00b3682454ae39e31d.svg";
export { ForwardRef as ReactComponent };